export const GEAR_ACTIONS_ALLOWED_FOR_DOCUMENT = {
  NONE: 0,
  DOWNLOAD: 1,
  LOCK: 1 << 1,
  UPDATE: 1 << 2,
  DELETE: 1 << 3
};

export type GearUserAllowedActions =
  (typeof GEAR_ACTIONS_ALLOWED_FOR_DOCUMENT)[keyof typeof GEAR_ACTIONS_ALLOWED_FOR_DOCUMENT];
